// frontend/src/services/WebSocketEvents.js
import { EventEmitter } from 'events';

class WebSocketEvents extends EventEmitter {
  constructor() {
    super();
    this.setMaxListeners(20); // Increase max listeners
    // Don't log anything on construction - wait for first use
  }
  
  emitStatusUpdate(entityId, tripId, status, additional = {}) {
    // Only log if user is authenticated
    if (!localStorage.getItem('token')) {
      return;
    }

    console.log('Emitting WebSocket status update', { entityId, tripId, status });

    const data = { entityId, tripId, status, ...additional };
    this.emit('status_update', data);

    // Log listener count
    const count = this.listenerCount('status_update');
    console.log('WebSocket status update emitted', { entityId, tripId, status, listenerCount: count });
  }

  emitSurveyReminderTrigger(entityId, tripId, eligibleRiderIds) {
    // Only log if user is authenticated
    if (!localStorage.getItem('token')) {
      return;
    }

    console.log('Emitting survey reminder trigger', { entityId, tripId, eligibleRiderCount: eligibleRiderIds.length });

    const data = { entityId, tripId, eligibleRiderIds };
    this.emit('survey_reminder_trigger', data);

    // Log listener count
    const count = this.listenerCount('survey_reminder_trigger');
    console.log('Survey reminder trigger emitted', { entityId, tripId, listenerCount: count });
  }

  emitTripDelayUpdated(entityId, tripId, payload = {}) {
    if (!localStorage.getItem('token')) return;
    this.emit('trip_delay_updated', { entityId, tripId, ...payload });
  }

  // Debug helper method
  getListeners(event) {
    return this.listeners(event);
  }
}

export default new WebSocketEvents();
